// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import { deleteProject, getAllProjects, getProject, updateProject } from '../../helpers/backend_helper';
import { fetchProjectsFailure, fetchProjectsSuccess, updateProjectFailure, updateProjectSuccess } from './actions';
import { deleteProjectFailure, deleteProjectSuccess, fetchProjectFailure, fetchProjectSuccess } from '../actions';
import { DELETE_PROJECTS_REQUEST, FETCH_PROJECTS_REQUEST, FETCH_PROJECT_REQUEST, UPDATE_PROJECTS_REQUEST } from './actionTypes';
import { reduxSerializedError } from '../../utils/utils';

function* fetchProjectsSaga() {
  try {
    const response = yield call(getAllProjects);

    // Store the mapping in localStorage
    yield put(fetchProjectsSuccess(response.data));
  } catch (error) {
    yield put(fetchProjectsFailure(reduxSerializedError(error)));
  }
}

function* fetchProjectSaga({ payload }) {
  try {
    const response = yield call(getProject, payload);
    yield put(fetchProjectSuccess(response));
  } catch (error) {
    yield put(fetchProjectFailure(reduxSerializedError(error)));
  }
}

function* deleteProjectsSaga({ payload }) {
  try {
    yield call(deleteProject, payload);
    yield put(deleteProjectSuccess(payload));
    yield call(fetchProjectsSaga);
  } catch (error) {
    yield put(deleteProjectFailure(reduxSerializedError(error)));
  }
}

function* updateProjectSaga({ payload }) {
  const { project } = payload;
  try {
    yield call(updateProject, project);
    yield put(updateProjectSuccess());
    yield call(fetchProjectsSaga); 
  } catch (error) {
    yield put(updateProjectFailure(reduxSerializedError(error)));
  }
}


export default function* rootSaga() {
  yield takeEvery(FETCH_PROJECTS_REQUEST, fetchProjectsSaga);
  yield takeEvery(FETCH_PROJECT_REQUEST, fetchProjectSaga);
  yield takeEvery(UPDATE_PROJECTS_REQUEST, updateProjectSaga);
  yield takeEvery(DELETE_PROJECTS_REQUEST, deleteProjectsSaga);
}
